import React from 'react';
import HeaderPanel from 'ff/debrief/layouts/HeaderPanel';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import WhatsNewButton from 'ff/debrief/components/whatsNew/WhatsNewButton';
import SettingsButton from 'ff/debrief/components/settings/SettingsButton';

const Header = (props: React.PropsWithChildren) => {
    return (
        <HeaderPanel>
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                sx={{ width: '100%' }}
            >
                <Typography variant="h1" color="#F9F9F9">
                    Track Logs
                </Typography>

                <Stack direction="row" spacing={1}>
                    {props.children}
                    <SettingsButton />
                    <WhatsNewButton />
                </Stack>
            </Stack>
        </HeaderPanel>
    );
};

export default Header;
